import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'apuracoes-vencidas');

const apuracoesVencidasActions = {
  listarTipos: { method: 'GET', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}/por-tipo` },
  cancelar: { method: 'PUT', url: `${basePath}/cancelar` },
  cancelarApuracoes: { method: 'PUT', url: `${basePath}/cancelar-apuracoes` },
};

export default resource => resource(`${basePath}`, {}, apuracoesVencidasActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracoes-vencidas.js